import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  profile: {},
};

const userSlice = createSlice({
  name: "user",
  initialState:{
    selectedOwnerIds: [],
  },
  reducers: {
    setProfile: (state, action) => {
      state.profile = action.payload;
    },
    setSelectedOwners: (state, action) => {
      state.selectedOwnerIds = action.payload; // Only store IDs
  },
  },
});

export const { setProfile,setSelectedOwners } = userSlice.actions;
export default userSlice.reducer;